import React from "react";
import { Switch, Redirect } from "react-router-dom";
import SuperRoute from "hoc/Routes/SuperRoute/SuperRoute";
import { useSelector } from "react-redux";
import PricingIndex from "./Pricing";
import SupportIndex from "./Support";
import FinancialIndex from "./Financial";
import ToolsIndex from "./Tools";
import StatisticsIndex from "./Statistics";
import SuperLayout from "hoc/SuperLayout";
import TicketsIndex from "./Tickets";
import NoticesIndex from "./Notice";


export default function SuperIndex(props) {
  const { isLoggedIn } = useSelector((state) => ({
    isLoggedIn: state.auth.isLoggedIn,
  }));
  return (
    <SuperLayout {...props}>
      <Switch>
        <Redirect exact from="/admin" to="/admin/support" />
        <SuperRoute path="/admin/pricing" component={PricingIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/support" component={SupportIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/tickets" component={TicketsIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/notices" component={NoticesIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/financial" component={FinancialIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/tools" component={ToolsIndex} isLoggedIn={isLoggedIn}/>
        <SuperRoute path="/admin/statistics" component={StatisticsIndex} isLoggedIn={isLoggedIn}/>
      </Switch>
    </SuperLayout>
  );
}
